import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconPermIdentitySvg } from "./IconPermIdentitySvg.mjs";
const IconPermIdentity = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconPermIdentitySvg, ...iconProps });
};
export {
  IconPermIdentity
};
